import { useState } from "react";
import "./Feedback.css";
import api from "../../api";
import { createStandaloneToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
const feedback = require("../../assets/feedback.png");

const { toast } = createStandaloneToast();

export function Feedback() {
  const [feedbackText, setFeedbackText] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  async function handleFeedbackSubmit() {
    setIsLoading(true);
    if (localStorage.getItem("isGuest") !== "T") {
      await api.post("/account/feedback", { feedback: feedbackText });
    }
    toast({
      title: "Feedback successfully submitted!",
      status: "success",
      duration: 5000,
      isClosable: true,
      position: "top",
      variant: "subtle",
    });
    setFeedbackText("");
    setIsLoading(false);
    return navigate("/");
  }
  return (
    <div className="pageContainer">
      <div className="feedbackPage">
        <img src={feedback} className="feedbackImage" alt="feedback"></img>
        <div className="feedbackContainer">
          <div className="feedbackHeader">
            <h4>Thanks for stopping by</h4>
            <h6>We'd love to hear your feedback!</h6>
          </div>
          <textarea
            rows={7}
            cols={10}
            className="feedbackInput"
            placeholder="Share your thoughts..."
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
          ></textarea>
          <h6>
            Or feel free to send us an email at{" "}
            <a href="mailto:operations@pickandprice.co.za" className="betaLink">
              operations@pickandprice.co.za
            </a>
          </h6>
        </div>
        {isLoading ? (
          <div className="spinner spinner_small"></div>
        ) : (
          <button
            className={`primaryButton feedbackButton ${feedbackText.length === 0 ? "invalid" : ""}`}
            onClick={handleFeedbackSubmit}
          >
            SUBMIT
          </button>
        )}
      </div>
    </div>
  );
}
